import { Box, Switch, Typography } from '@mui/material';
import { ReactElement } from 'react';
import { getBTNsStyles } from './styles';
import { CompareSource } from '../../constants';

interface Props {
  value: CompareSource;
  handleChange: (value: CompareSource) => void;
}

export function CompareToggles({ value, handleChange }: Props): ReactElement {
  const styles = getBTNsStyles();

  return (
    <Box sx={styles.wrapper}>
      <Typography sx={styles.toggle}>COMPARE</Typography>
      <Switch
        checked={value === CompareSource.SEO}
        onChange={() => handleChange(value === CompareSource.SEO ? CompareSource.Original : CompareSource.SEO)}
        color="primary"
      />
      <Typography sx={styles.toggle}>SEO COMPARE</Typography>
    </Box>
  );
}
